import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import '../css/ofertas.css'; // Estilos separados
import ScrollToTopButton from "../components/scrollButton";
import { ENDPOINTS } from "../config/api"; // <-- Importa tus endpoints

const Ofertas = () => {
  const [ofertas, setOfertas] = useState([]);
  const [busqueda, setBusqueda] = useState(""); // Estado para el buscador

  useEffect(() => {
    fetch(ENDPOINTS.getOfertas)
      .then(response => response.json())
      .then(data => setOfertas(data))
      .catch(error => console.error("Error al cargar ofertas:", error));
  }, []);

  // Filtrar ofertas según el texto del buscador
  const ofertasFiltradas = ofertas.filter(oferta =>
    oferta.professional_program.toLowerCase().includes(busqueda.toLowerCase())
  );

  return (
    <div className="container mt-5 ofertas">
      <h2 className="mb-4">NUESTRAS OFERTAS LABORALES</h2>

      {/* Buscador */}
      <div className="d-flex mb-4">
        <input
          type="text"
          className="form-control form-control-lg"
          placeholder="Buscar por nombre del programa..."
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
        />
      </div>

      {/* Si no hay resultados */}
      {ofertasFiltradas.length === 0 ? (
        <div className="text-center text-muted mt-5 mb-5">
          <i className="bi bi-search fs-3 d-block mb-2"></i>
          <h5>No se encontraron ofertas que coincidan con la búsqueda.</h5>
        </div>
      ) : (
        <div className="row">
          {ofertasFiltradas.map((oferta) => (
            <div className="col-12 mb-4" key={oferta.IdOfertas}>
              <div className="card shadow-sm p-4">
                <div>
                  <h5 className="card-title mb-1 text-uppercase">{oferta.professional_program}</h5>
                  <p className="card-text mb-0 fst-italic">{oferta.area_name}</p>
                </div>

                {/* Funciones o descripción */}
                <p>{oferta.functions}</p>

                {/* Badges debajo de las funciones */}
                <div className="mb-2">
                  <span className="badge badge-pink me-2">
                    Salario: {oferta.salary ? `$${oferta.salary}` : "A convenir"}
                  </span>
                  <span className="badge badge-purple me-2">
                    Contrato: {oferta.type_contract}
                  </span>
                  <span className="badge badge-pink">
                    Experiencia: {oferta.experience}
                  </span>
                </div>

                {/* Fecha y botón */}
                <div className="d-flex justify-content-between align-items-center text-muted small">
                  <div>
                    <span className="me-4">Lugar: {oferta.place}</span>
                    <span>Fecha: {oferta.created_at}</span>
                  </div>
                  <Link 
                    to={`/detalleOferta/${oferta.IdOfertas}`} 
                    className="btn btn-sm btn-outline-pink"
                  >
                    Ver detalle
                  </Link>
                </div>
              </div>
            </div>
          ))}
          {/* <div className="col"></div> */}
        </div>
      )}
      {/* Boton flotante */}
      <ScrollToTopButton />
    </div>
  );
};

export default Ofertas;
